export default __webpack_public_path__ + "static/media/menuMover.7556390b.svg";